/**
 * Chain Data Types
 *
 * Types for blockchain chain configuration.
 */
export const ChainTypes = {
    PRIVATE: "PRIVATE",
    PUBLIC: "PUBLIC"
};
